export default "__VITE_ASSET__DLzvPaGO__"